import React from 'react';
import { Box, Typography } from '@mui/material';
import { mvkgTokens, shellTokens } from '../../theme/mvkgTokens';

const DOT_COLORS = {
  success: '#10b981',
  brand: mvkgTokens.brand.main,
  warning: '#f59e0b',
  error: '#f43f5e',
};

/**
 * Status filter row. The active pill speaks the shell's dialect (chip-grey fill,
 * ink text, like the active sidebar item) instead of a solid indigo block with a
 * glow, so the Library matches the frame around it.
 */
export default function LibraryStatusPills({ value, onChange, options }) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {options.map((opt) => {
        const active = value === opt.id;
        return (
          <Box
            key={opt.id}
            component="button"
            type="button"
            onClick={() => onChange(opt.id)}
            aria-pressed={active}
            sx={{
              border: `1px solid ${active ? 'transparent' : shellTokens.rule}`,
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1,
              px: 2,
              py: 1,
              borderRadius: `${shellTokens.controlRadius}px`,
              bgcolor: active ? shellTokens.nav.activeBg : shellTokens.surface,
              color: active ? shellTokens.nav.activeText : 'text.secondary',
              '&:hover': { bgcolor: active ? shellTokens.nav.activeBg : shellTokens.nav.hover },
              '&:focus-visible': { outline: `2px solid ${mvkgTokens.brand.main}`, outlineOffset: 2 },
              fontWeight: active ? 700 : 600,
              fontSize: '0.8rem',
              transition: 'all 0.15s',
            }}
          >
            {opt.dot && (
              <Box
                component="span"
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  bgcolor: DOT_COLORS[opt.dot],
                  flexShrink: 0,
                }}
              />
            )}
            <span>{opt.label}</span>
            {opt.count != null && (
              <Typography
                component="span"
                sx={{
                  fontFamily: mvkgTokens.font.mono,
                  fontSize: '0.6875rem',
                  fontWeight: 700,
                  px: 0.75,
                  py: 0.25,
                  borderRadius: 1,
                  bgcolor: active ? shellTokens.surface : shellTokens.nav.hover,
                  color: 'text.secondary',
                }}
              >
                {opt.count}
              </Typography>
            )}
          </Box>
        );
      })}
    </Box>
  );
}
